import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetTransactionEvidenceEmailAddressRequest,
  DefaultApiRegisterTransactionEvidenceEmailAddressRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getTransactionEvidenceEmailAddress = async (
  instance: AxiosInstance,
  params: DefaultApiGetTransactionEvidenceEmailAddressRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getTransactionEvidenceEmailAddress(params)
}

export const registerTransactionEvidenceEmailAddress = async (
  instance: AxiosInstance,
  params: DefaultApiRegisterTransactionEvidenceEmailAddressRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).registerTransactionEvidenceEmailAddress(params)
}

// Do Not Remove this line ===@import api client===
